/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { JsonNode } from '../models/JsonNode';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OwnerRestControllerService {
    /**
     * @returns JsonNode OK
     * @throws ApiError
     */
    public static findOwnerInformation(): CancelablePromise<JsonNode> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/owner',
        });
    }
    /**
     * @returns JsonNode OK
     * @throws ApiError
     */
    public static updateOwnerInformation({
        requestBody,
    }: {
        requestBody: Record<string, any>,
    }): CancelablePromise<JsonNode> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dashboard/api/v1/owner',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
